import { connect } from 'react-redux';
import asContentPage from 'components/hoc/asContentPage';
import { forceMiniPlayerState } from 'actions/player-actions';
import { setHidden } from 'actions/search-actions';

import withContentfulData from 'components/hoc/withContentfulData';

import FaqLandingPage from './FaqLandingPage';

const FaqLandingPageContainer = connect(null, {
  forceMiniPlayerState,
  setSearchHidden: setHidden,
})(FaqLandingPage);
export default asContentPage('faqLandingPage', withContentfulData(FaqLandingPageContainer));
